import { React } from "react";
import { Component } from "react";

import { listAdminData } from "./../../../config/reseller_api_calls";
import HelperClass from "./../../../config/helperClass";
import { LOGO, ADMIN_URL } from "../../../config/config"; // You can add your theme color if needed
import { ThreeDots } from "../../../components/ContentLoaders/newLoaders/ThreeDots";

const auth = new HelperClass();

export default class PrivacyPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comp_name: "",
      logo: "",
      address: "",
      city: "",
      state: "",
      country: "",
      zip: "",
      phone: "",
      email: "",
      pageContent: "",
      pageTitle: "",
      imageLoader: true,
      haveData: "",
    };
  }

  async componentDidMount() {
    const { pageUrl } = this.props.match.params;
    const adminresponse = await listAdminData(
      auth.getAccount(),
      auth.getToken(),
      pageUrl
    );
    console.log("Page Info: ", adminresponse.data);

    if (
      adminresponse.data.status === 403 ||
      adminresponse.data.errors === "authentication missing" ||
      adminresponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      adminresponse.data.status === 404 ||
      adminresponse.data.note === "missing"
    ) {
      this.setState({ tableLoader: false });
    } else if (
      adminresponse.data.status === 200 &&
      adminresponse.data.message === "success"
    ) {
      const data = adminresponse.data.data[0];

      const fullAddress = `${data.address}, ${data.city}, ${data.state}, ${data.country} - ${data.zip}`;

      // Replace placeholders with actual values
      let fixedContent = "";
      let pageContentData = [];
      let page_title = "";
      let haveData = "";
      if (
        adminresponse.data.pageContent &&
        adminresponse.data.pageContent.length > 0
      ) {
        pageContentData = adminresponse.data.pageContent[0];
        fixedContent = pageContentData.page_content;
        page_title = pageContentData.page_title;
        document.title = `${page_title} - ${data.comp_name}`;

        const formattedDate = new Date().toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });

        // Replace dynamic placeholders with actual values
        fixedContent = fixedContent
          .replace(/{email}/g, data.email)
          .replace(/{phone}/g, data.phone)
          .replace(/{fullAddress}/g, fullAddress)
          .replace(/{comp_name}/g, data.comp_name)
          .replace(/{LOGO}/g, LOGO)
          .replace(/{title}/g, pageContentData.page_title)
          .replace(/{date}/g, formattedDate);
        page_title = pageContentData.page_title;
        haveData = "Yes";
      } else {
        haveData = "No";
      }

      this.setState({
        comp_name: data.comp_name,
        logo: data.logo,
        address: data.address,
        city: data.city,
        state: data.state,
        country: data.country,
        zip: data.zip,
        phone: data.phone,
        email: data.email,
        pageContent: fixedContent,
        pageTitle: page_title,
        imageLoader: false,
        haveData: haveData,
      });
    } else {
      //window.location.replace("/error");
    }
  }

  render() {
    return (
      <div className="nk-content" style={{ backgroundColor: '#f5f6fa', minHeight: '100vh' }}>
        <div className="container-fluid">
          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* Logo Section - Fixed Position */}
              <div style={{
                textAlign: 'center',
                marginBottom: '1.25rem',
                paddingTop: '1rem'
              }}>
                {this.state.imageLoader === true ? (
                  ThreeDots()
                ) : (
                  <img
                    src={`${ADMIN_URL}files_data/logos/${this.state.logo}`}
                    alt="Company Logo"
                    style={{
                      maxHeight: '60px',
                      height: 'auto',
                      display: 'block',
                      margin: '16px auto'
                    }}
                  />
                )}
              </div>

              {this.state.haveData === "Yes" ? (
                // FULL WIDTH CONTAINER LIKE IMAGE 1
                <div>
                  {/* BOLD HEADINGS + VISIBLE CARD + TIGHTER SPACING */}
                  <style dangerouslySetInnerHTML={{
                    __html: `
                      /* Remove Nunito Import Completely */
                      
                      .bold-card-privacy-container {
                        background-color: #f8f9fa !important;
                        padding: 2rem !important;
                        padding-bottom: 0rem !important;
                        width: calc(100% - 4rem) !important;
                        margin: 0 2rem !important;
                        border-radius: 8px !important;
                        box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.15) !important;
                        border: 1px solid #e3e6ea !important;
                        font-size: 1.125rem !important;
                        line-height: 1.6 !important;
                        font-family: 'Nunito', -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif !important;
                        color: #333 !important;
                      }
                      
                      /* Remove any nested containers */
                      .bold-card-privacy-container > div:first-child {
                        background: none !important;
                        padding: 0 !important;
                        margin: 0 !important;
                        box-shadow: none !important;
                        border-radius: 0 !important;
                      }
                      
                      /* Title Styling - System Font Stack */
                      .bold-card-privacy-container h1,
                      .bold-card-privacy-container .title-span,
                      .bold-card-privacy-container > div h1,
                      .bold-card-privacy-container span {
                        color: rgb(74, 74, 74) !important;
                        font-size: 2.5rem !important;
                        font-weight: normal !important;
                        text-align: center !important;
                        margin: 1rem 0 1.5rem 0 !important;
                        padding: 0 !important;
                        line-height: 1.2 !important;
                        display: block !important;
                        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important;
                      }
                      
                      /* Section Headings - BOLD */
                      .bold-card-privacy-container h2 {
                        font-size: 1.5rem !important;
                        color: #364a63 !important;
                        font-weight: 700 !important;
                        margin: 1.5rem 0 0.75rem 0 !important;
                        padding: 0 !important;
                        line-height: 1.3 !important;
                        font-family: 'Nunito', sans-serif !important;
                      }
                      
                      .bold-card-privacy-container h3 {
                        font-size: 1.25rem !important;
                        color: #364a63 !important;
                        font-weight: 700 !important;
                        margin: 1.25rem 0 0.5rem 0 !important;
                        padding: 0 !important;
                        font-family: 'Nunito', sans-serif !important;
                      }
                      
                      /* Paragraph Text - Better Spacing and Font Weight */
                      .bold-card-privacy-container p {
                        color: #333 !important;
                        font-size: 1.125rem !important;
                        line-height: 1.6 !important;
                        margin: 0 0 1rem 0 !important;
                        padding: 0 !important;
                        font-weight: 500 !important;
                        font-family: 'Nunito', sans-serif !important;
                      }
                      
                      /* List Styling - Better Spacing Like Image 1 */
                      .bold-card-privacy-container ul {
                        margin-left: 20px !important;
                        padding-left: 20px !important;
                        list-style-type: disc !important;
                        margin-bottom: 1.25rem !important;
                        margin-top: 0.5rem !important;
                        color: #333 !important;
                      }
                      
                      .bold-card-privacy-container ul li {
                        color: #333 !important;
                        font-size: 1.125rem !important;
                        line-height: 1.6 !important;
                        margin-bottom: 0.25rem !important;
                        margin-top: 0 !important;
                        padding: 0 !important;
                        font-weight: 500 !important;
                        list-style-type: disc !important;
                        display: list-item !important;
                        font-family: 'Nunito', sans-serif !important;
                      }
                      
                      .bold-card-privacy-container li::marker {
                        color: #333 !important;
                      }
                      
                      /* Dividers - More Visible Like Image 1 */
                      .bold-card-privacy-container hr {
                        border: none !important;
                        height: 1px !important;
                        background-color: #c7ccd1 !important;
                        margin: 1.5rem 0 !important;
                        padding: 0 !important;
                        width: 100% !important;
                      }
                      
                      /* Bold Text */
                      .bold-card-privacy-container strong {
                        color: #333 !important;
                        font-weight: 700 !important;
                        font-family: 'Nunito', sans-serif !important;
                      }
                      
                      /* Links */
                      .bold-card-privacy-container a {
                        color: #006393 !important;
                        text-decoration: none !important;
                        font-family: 'Nunito', sans-serif !important;
                      }
                      
                      /* Sections - Better Spacing Like Image 1 */
                      .bold-card-privacy-container section {
                        margin-bottom: 2rem !important;
                        margin-top: 0 !important;
                        padding: 0 !important;
                      }
                      
                      /* Apply Nunito to specific elements, not title */
                      .bold-card-privacy-container p,
                      .bold-card-privacy-container li,
                      .bold-card-privacy-container strong,
                      .bold-card-privacy-container a,
                      .bold-card-privacy-container h2,
                      .bold-card-privacy-container h3 {
                        font-family: 'Nunito', sans-serif !important;
                      }
                      
                      /* Remove any duplicate containers */
                      .bold-card-privacy-container .privacy-container,
                      .bold-card-privacy-container .privacy-policy-container {
                        background: none !important;
                        padding: 0 !important;
                        margin: 0 !important;
                        box-shadow: none !important;
                        border-radius: 0 !important;
                      }
                    `
                  }} />

                  <div
                    className="bold-card-privacy-container"
                    dangerouslySetInnerHTML={{
                      __html: this.state.pageContent
                        // Remove any duplicate container divs from content
                        .replace(/<div[^>]*style="background-color[^"]*"[^>]*>/g, '<div>')
                        .replace(/<div[^>]*class="[^"]*container[^"]*"[^>]*>/g, '<div>')
                    }}
                  />
                </div>
              ) : this.state.haveData === "No" ? (
                <div className="alert alert-pro alert-warning" style={{
                  backgroundColor: '#fff3cd',
                  border: '1px solid #ffeaa7',
                  borderRadius: '8px',
                  padding: '1rem',
                  margin: '2rem auto',
                  maxWidth: '800px'
                }}>
                  <div className="alert-text">
                    <h6 style={{ color: '#856404', marginBottom: '0.5rem' }}>Page Not Found</h6>
                    <p style={{ color: '#856404', margin: '0' }}>Page you are looking for does not exist at the moment.</p>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
